module.exports = __webpack_public_path__ + "static/wedding-andika-69c7298b9526dc369f16d51387f3ad0d.png";